export default {
  sans: ["Lato", "sans-serif"],
};
